import type * as router from '@attain-apps/fe/web/main/lib/router'
import * as store from '@attain-apps/fe/web/main/lib/store'

import { State } from './state'

/**
 * Actions for page navigation transition state.
 */
export function getActionsConfig() {
  return {
    /**
     * Finishes a visual transition if it is still the currently active one.
     */
    finishTransition: store.actions.standalone({
      data: store.actions.Data.asIs<{
        id: number
      }>(),
      reducer: ({ state, data }) => State.finishTransition(state, data.id),
    }),
    /**
     * Starts a visual transition before a route request that this feature owns.
     */
    navigate: store.actions.standalone({
      data: (data: AtLeastOneOf<router.models.Request>) => data,
    }),
    /**
     * Signals that the app-page pseudo-router outlet rendered the selected page.
     */
    pageRendered: store.actions.standalone({
      data: store.actions.Data.NONE,
    }),
    /**
     * Starts a visual transition for route requests this feature did not start.
     */
    startTransition: store.actions.standalone({
      data: store.actions.Data.NONE,
      reducer: ({ state }) => State.startTransition(state),
    }),
  } as const satisfies store.actions.Config.Constraint<State>
}
